import axios from 'axios';
import aws from './aws';

export const useNetwork = () => {
  const getBaseUrl = (withLang = true) => {
    const lang = window.location.pathname.split('/')[1];
    return window.location.origin + (lang && withLang ? '/' + lang : '');
  };

  const exhibitorSearch = async (params, accountIds = []) => {
    return await aws.API.azureSearch(params, accountIds);
  };

  const exhibitorGet = async (brandId) => {
    return await aws.API.azureGetExhibitor(brandId);
  };

  const analitycsSearch = async (params) => {
    return await aws.API.azureAnalyticsSearch(params);
  };

  const fetchEntityFieldsForm = async (params) => {
    return await aws.API.getEntityFieldsForm(params);
  };

  const fetchEntityReferenceRevisionsFieldsForm = async (params) => {
    return await aws.API.getEntityReferenceRevisionsFieldsForm(params);
  };

  const ticketingLambda = async (params) => {
    return await aws.API.azureTicketingLambda(params);
  };

  const azureMatchmakingLambda = async (params) => {
    return await aws.API.azureMatchmakingLambda(params);
  };

  const azureLambda = async (params) => {
    return await aws.API.azureFlexLambda(params);
  };

  const aggregateTicketingLambda = async (params) => {
    return await aws.API.azureAggregateTicketingLambda(params);
  };

  const checkCodeLambda = async (params) => {
    return await aws.API.internalCheckCodeLambda(params);
  };

  const checkCodesBeforeOrderLambda = async (params) => {
    return await aws.API.internalCheckCodesBeforeOrderLambda(params);
  };

  const aggregatePersonalTicketsLambda = async (params) => {
    return await aws.API.develonAggregatePersonalTicketLambda(params);
  };

  const salesforceCustomerLambda = async (params) => {
    return await aws.API.azureSalesforceCustomerLambda(params);
  };

  const ticketPdfLambda = async (params) => {
    return await aws.API.getTicketPdf(params);
  };

  const drupalCustomApiLambda = async (params) => {
    return await aws.API.customApiLambda(params);
  };

  const generateStripeSession = async (params) => {
    return await aws.API.createStripeSession(params);
  };

  const analyticsTicketHandler = async (params) => {
    return await aws.API.azureAnalyticsTicketHandler(params);
  };

  const agendaLambda = async (params, path) => {
    return await aws.API.agendaHandler(params, path);
  };

  const get = async (url, config = {}) => {
    const _config = {
      ...config,
      url: url,
    };
    return send(url, _config, 'get');
  };
  const post = async (url, data, config = {}) => {
    const _data = JSON.stringify(data);
    const _config = {
      ...config,
      url: url,
      data: _data,
    };
    return send(url, _config, 'post');
  };
  const patch = async (url, data, config = {}) => {
    const _data = JSON.stringify(data);
    const _config = {
      ...config,
      url: url,
      data: _data,
    };
    return send(url, _config, 'patch');
  };

  const sendImage = async (url, fileData, config = {}) => {
    const _config = {
      ...config,
      url: url,
      data: fileData,
    };
    return send(url, _config, 'put');
  };

  const send = async (url, config, method) => {
    const _config = {
      ...config,
      url: url,
      method: method,
    };
    return await axios(_config);
  };

  const getImage = async (url, config) => {
    const _config = {
      ...config,
      url: url,
      responseType: 'arraybuffer',
      method: 'get',
    };
    return axios(_config);
  };

  const getExhibitorLogoUrl = async (salesforceId) => {
    const baseUrl = getBaseUrl() + '/api/sdm-rest-logo';
    const url = `${baseUrl}/${salesforceId}`;
    return url;
  };

  return {
    get,
    post,
    patch,
    sendImage,
    getImage,
    exhibitorSearch,
    analitycsSearch,
    getExhibitorLogoUrl,
    getBaseUrl,
    analyticsTicketHandler,
    ticketingLambda,
    azureMatchmakingLambda,
    aggregateTicketingLambda,
    checkCodeLambda,
    checkCodesBeforeOrderLambda,
    generateStripeSession,
    ticketPdfLambda,
    agendaLambda,
    exhibitorGet,
    fetchEntityFieldsForm,
    fetchEntityReferenceRevisionsFieldsForm,
    salesforceCustomerLambda,
    drupalCustomApiLambda,
    azureLambda,
    aggregatePersonalTicketsLambda,
  };
};
